import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { EditorAnalyticsContext } from '../EditorAnalyticsContext';
import { DatasourceEventsBinding } from './DatasourceEvents';
import { LinkEventsBinding } from './LinkEvents';

// eslint-disable-next-line @repo/internal/react/no-class-components
export var EditorLinkingPlatformAnalytics = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(EditorLinkingPlatformAnalytics, _React$PureComponent);
  var _super = _createSuper(EditorLinkingPlatformAnalytics);
  function EditorLinkingPlatformAnalytics() {
    _classCallCheck(this, EditorLinkingPlatformAnalytics);
    return _super.apply(this, arguments);
  }
  _createClass(EditorLinkingPlatformAnalytics, [{
    key: "render",
    value:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

    function render() {
      var _this$context;
      var cardContext = (_this$context = this.context) === null || _this$context === void 0 || (_this$context = _this$context.contextAdapter) === null || _this$context === void 0 ? void 0 : _this$context.card;

      /**
       * The analytics hook needs to be able to communicate with the card context
       * If we can't access it, don't mount the event bindings
       * This effectively entirely disables all tracking behaviour
       */
      if (!(cardContext !== null && cardContext !== void 0 && cardContext.value)) {
        return null;
      }
      return /*#__PURE__*/React.createElement(cardContext.Provider, {
        value: cardContext.value
      }, /*#__PURE__*/React.createElement(EditorAnalyticsContext, {
        editorView: this.props.editorView
      }, /*#__PURE__*/React.createElement(LinkEventsBinding, this.props), /*#__PURE__*/React.createElement(DatasourceEventsBinding, this.props)));
    }
  }]);
  return EditorLinkingPlatformAnalytics;
}(React.PureComponent);
_defineProperty(EditorLinkingPlatformAnalytics, "contextTypes", {
  contextAdapter: PropTypes.object
});